<template>
  <left-right-wrapper>
    <template v-slot:left>
      <customer-management-list :data="$store.state.admin.customers" @select="selectHandler" @refresh="refreshHandler" :selected-id="selectedID" />
    </template>
    <template v-slot:right>
      <customer-management-details :data="selectedItem" @refresh="refreshHandler" />
    </template>
  </left-right-wrapper>
</template>


<script>
    import CustomerManagementList from "./CustomerManagementList";
    import LeftRightWrapper from "../LeftRightWrapper";
    import CustomerManagementDetails from "./CustomerManagementDetails";
    export default {
      name: "CustomerManagement",
      components: {CustomerManagementDetails, LeftRightWrapper, CustomerManagementList},
      async mounted() {
        await this.$store.dispatch('admin/listCustomers')
      },
      data: function() {
        return {
          selectedItem: null,
          selectedID: null
        }
      },
      methods: {
        selectHandler: function(item) {
          this.selectedItem = item
        },
        refreshHandler: async function() {
          let lastSelectedID = null
          if (this.selectedDevice) {
            lastSelectedID = this.selectedDevice.ID
          }
          await this.$store.dispatch('admin/listCustomers')
          let devices = (this.$store.state.admin.devices || [])
          if (!lastSelectedID) return
          for (let i = 0; i < devices.length; i++) {
            if (devices[i].ID === lastSelectedID) {
              this.selectedID = devices[i].ID // force grid to select back
              this.selectedDevice = devices[i]
              return
            }
          }
        }
      }
    }
</script>

<style scoped lang="less">
</style>
